import Vue from 'vue'
import Vuex from 'vuex'

import { Module, createStore } from 'vuex-smart-module'

import { loading } from './modules/loading'
import { mobileWidth } from '@/store/modules/mobileWidth'
import { navBarTitle } from './modules/navbar'
import { toast } from './modules/toast'
import { user } from './modules/user'
import { notifications } from './modules/notifications'
import { logger } from './modules/logger'
Vue.use(Vuex)

const root = new Module({
  modules: {
    loading,
    mobileWidth,
    navBarTitle,
    toast,
    user,
    notifications,
    logger,
  },
})

export default createStore(root)
